import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ documentTemplateId = '', ...params }) => {
  return await dponetAPI.get(`/document_templates/${documentTemplateId}`, {
    params,
  })
}

const generate = async ({ documentTemplateId = '', ...data }) => {
  return await dponetAPI.post(
    `/document_templates/${documentTemplateId}/generate`,
    data,
  )
}

const getFolders = async ({ folderId = '', ...params }) => {
  return await dponetAPI.get(`/document_templates/folders/${folderId}`, {
    params,
  })
}

export default {
  get,
  generate,
  getFolders,
}
